var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ObjectTreeView_1;
import { AddMapObject } from "Server/Commands/AddMapObject";
import { DeleteMapObject } from "Server/Commands/DeleteMapObject";
import { ReparentMapObject } from "Server/Commands/ReparentMapObject";
import { MapObject } from "Store/firebase/mapObjects/@MapObject";
import { GetCopiedMapObject } from "Store/main";
import { ShowSignInPopup } from "UI/@Shared/NavBar/UserPanel";
import { PanelHeader } from "UI/Write/MapUI/Panel";
import { VRect, Vector2i, E } from "js-vextensions";
import { Button, Column } from "react-vcomponents";
import { BaseComponentPlus } from "react-vextensions";
import { VMenuItem, VMenuStub } from "react-vmenu";
import { ShapeType, ShapeComp } from "Store/firebase/mapObjects/Components/@ShapeComp";
import { ShowMessageBox } from "react-vmessagebox";
import { TreeView, Observer } from "vwebapp-framework";
import { ForCut_GetError, ForDelete_GetError, GetMapObject, GetMapObjectChildren, GetSelectedMapObject } from "../../../../Store/firebase/mapObjects";
import { styles } from "Utils/UI/GlobalStyles";
import { runInAction } from "mobx";
import { store } from "Store";
import { MeID } from "Store/firebase/users";
import { CanGetBasicPermissions } from "Store/firebase/userExtras";
let ObjectsPanel = class ObjectsPanel extends BaseComponentPlus({}, {}) {
    render() {
        const { book } = this.props;
        const rootObject = GetMapObject(book.rootMapObject);
        return (React.createElement(Column, null,
            React.createElement(PanelHeader, { text: "Objects" },
                React.createElement(Button, { text: "+", onClick: () => {
                        const newObject = new MapObject({ name: "TODO", position: new Vector2i(3, 3) });
                        newObject.shape = new ShapeComp({ type: ShapeType.Rectangle, rect: new VRect(0, 0, 1, 1) });
                        new AddMapObject({ object: newObject, parentID: rootObject._key }).Run();
                    } })),
            React.createElement(Column, null,
                rootObject == null && "Loading...",
                rootObject && React.createElement(ObjectTreeView, { obj: rootObject }))));
    }
};
ObjectsPanel = __decorate([
    Observer
], ObjectsPanel);
export { ObjectsPanel };
let ObjectTreeView = ObjectTreeView_1 = class ObjectTreeView extends BaseComponentPlus({}, {}) {
    render() {
        const { obj } = this.props;
        const selected = GetSelectedMapObject() == obj;
        const objChildren = GetMapObjectChildren(obj);
        return (React.createElement(TreeView, { selected: selected, onContextMenu: e => { e.preventDefault(); e["noVMenu"] = true; }, title: React.createElement("span", { style: { flex: 1 }, onClick: () => {
                    runInAction("ObjectTreeView.onClick", () => store.main.write.selectedObject = obj._key);
                } },
                React.createElement("span", null, GetObjectDisplayText(obj)),
                React.createElement(ObjectMenu, { obj: obj })) }, objChildren.filter(a => a).map(child => {
            return React.createElement(ObjectTreeView_1, { key: child._key, obj: child });
        })));
    }
};
ObjectTreeView = ObjectTreeView_1 = __decorate([
    Observer
], ObjectTreeView);
function GetObjectDisplayText(obj) {
    return (obj.name || "_") + (obj.shape ? ` (${ShapeType[obj.shape.type].toLowerCase()})` : "");
}
let ObjectMenu = class ObjectMenu extends BaseComponentPlus({}, {}) {
    render() {
        const { obj } = this.props;
        const copiedObj = GetCopiedMapObject();
        const userID = MeID();
        return (React.createElement(VMenuStub, { preOpen: e => e.noVMenu != true },
            React.createElement(VMenuItem, { text: "Delete", style: styles.vMenuItem, enabled: ForDelete_GetError(MeID(), obj) == null, title: ForDelete_GetError(MeID(), obj), onClick: e => {
                    ShowMessageBox({
                        title: `Delete "${GetObjectDisplayText(obj)}"`, cancelButton: true,
                        message: `Delete the map-object "${GetObjectDisplayText(obj)}?`,
                        onOK: async () => {
                            await new DeleteMapObject(E({ id: obj._key })).Run();
                        },
                    });
                } }),
            CanGetBasicPermissions(MeID())
                && React.createElement(VMenuItem, { text: copiedObj ? React.createElement("span", null,
                        "Cut ",
                        React.createElement("span", { style: { fontSize: 10, opacity: .7 } }, "(right-click to clear)")) : "Cut", enabled: ForCut_GetError(userID, obj) == null, title: ForCut_GetError(userID, obj), style: styles.vMenuItem, onClick: e => {
                        e.persist();
                        runInAction("ObjectMenu.Cut.onClick", () => {
                            if (e.button == 2) {
                                store.main.copiedMapObjectID = null;
                                store.main.copiedMapObjectID_asCut = true;
                                return;
                            }
                            store.main.copiedMapObjectID = obj._key;
                            store.main.copiedMapObjectID_asCut = true;
                        });
                    } }),
            CanGetBasicPermissions(userID) && copiedObj
                && React.createElement(VMenuItem, { text: "Paste", style: styles.vMenuItem, onClick: async (e) => {
                        if (e.button != 0)
                            return;
                        if (userID == null)
                            return ShowSignInPopup();
                        await new ReparentMapObject({ childID: copiedObj._key, newParentID: obj._key }).Run();
                    } })));
    }
};
ObjectMenu = __decorate([
    Observer
], ObjectMenu);
